// calendar.js (em migração do global.js)

import { getOptionsFromMap } from './common';

export const WEEKDAYS = {
    SUNDAY: 0,
    MONDAY: 1,
    TUESDAY: 2,
    WEDNESDAY: 3,
    THURSDAY: 4,
    FRIDAY: 5,
    SATURDAY: 6
};

export const WEEKDAY_LABELS = {
    [WEEKDAYS.SUNDAY]: 'Domingo',
    [WEEKDAYS.MONDAY]: 'Segunda-feira',
    [WEEKDAYS.TUESDAY]: 'Terça-feira',
    [WEEKDAYS.WEDNESDAY]: 'Quarta-feira',
    [WEEKDAYS.THURSDAY]: 'Quinta-feira',
    [WEEKDAYS.FRIDAY]: 'Sexta-feira',
    [WEEKDAYS.SATURDAY]: 'Sábado'
};

export const WEEKDAY_OPTIONS = [
    { value: WEEKDAYS.SUNDAY, label: "Dom", full: "Domingo" },
    { value: WEEKDAYS.MONDAY, label: "Seg", full: "Segunda" },
    { value: WEEKDAYS.TUESDAY, label: "Ter", full: "Terça" },
    { value: WEEKDAYS.WEDNESDAY, label: "Qua", full: "Quarta" },
    { value: WEEKDAYS.THURSDAY, label: "Qui", full: "Quinta" },
    { value: WEEKDAYS.FRIDAY, label: "Sex", full: "Sexta" },
    { value: WEEKDAYS.SATURDAY, label: "Sáb", full: "Sábado" },
];

export const MONTHS = [
    { value: 0, label: "Janeiro" },
    { value: 1, label: "Fevereiro" },
    { value: 2, label: "Março" },
    { value: 3, label: "Abril" },
    { value: 4, label: "Maio" },
    { value: 5, label: "Junho" },
    { value: 6, label: "Julho" },
    { value: 7, label: "Agosto" },
    { value: 8, label: "Setembro" },
    { value: 9, label: "Outubro" },
    { value: 10, label: "Novembro" },
    { value: 11, label: "Dezembro" }
];

export const MONTH_LABELS = MONTHS.map(m => m.label);
export const MONTH_SHORT_LABELS = ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];

export const ACTIVITY_STATUS = {
    SCHEDULED: 0,
    CONCLUDED: 1,
    CANCELLED: 2,
    ABSENT: 3,
    LATE: 4
};

export const ACTIVITY_STATUS_LABELS = {
    [ACTIVITY_STATUS.SCHEDULED]: 'Agendado',
    [ACTIVITY_STATUS.CONCLUDED]: 'Concluído',
    [ACTIVITY_STATUS.CANCELLED]: 'Cancelado',
    [ACTIVITY_STATUS.ABSENT]: 'Falta',
    [ACTIVITY_STATUS.LATE]: 'Atrasado'
};

export const ACTIVITY_STATUS_OPTIONS = getOptionsFromMap(ACTIVITY_STATUS, ACTIVITY_STATUS_LABELS);
